<template>
  <div class="center" style="width: 100%;">
    <el-table v-if="mchtbshow" ref="wtyTableRef" border :fit="true" :data="tableList" size="mini" type="index"
      height="540px" class="show-table table" style="height: 100%; width:100% !important" highlight-current-row
      :cell-style="{ padding: '10px 0' }" :header-cell-style="{
        height: '20px',
        background: '#409eff',
        color: '#fff',
      }" @row-click="rowClick">
      <el-table-column type="index" align="center">
      </el-table-column>
      <el-table-column v-for="(item, index) in wtycolumnList" :key="index" :prop="item.prop"
        :formatter="item.prop === 'submitStatus' ? formatter : null" :align="item.align"
        :label="item.label"><!-- formatter 数据过滤 -->
      </el-table-column>

      <el-table-column align="center" width="400" label="操作">
        <template slot-scope="scope">
          <el-button size="small" :disabled="scope.row.submitStatus === true"
            @click.native.prevent.stop=" showDetail('submit', scope.row)" plain type="danger">
            商户进件
          </el-button>
          <el-button size="small" :disabled="!scope.row.submitStatus"
            @click.native.prevent.stop=" showDetail('update', scope.row)" plain type="warning">
            {{ scope.row.submitStatus === false ? '继续进件' : '进件信息修改' }}
          </el-button>
          <el-dropdown szie="mini" style="margin-left: 10px;" @command="submitWX($event, scope.row.merchant_id)">
            <el-button size="small" type="primary">
              进 件<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="wx">微信进件</el-dropdown-item>
              <el-dropdown-item command="swift">随行付进件</el-dropdown-item>
              <!-- <el-dropdown-item>螺蛳粉</el-dropdown-item>
              <el-dropdown-item>双皮奶</el-dropdown-item>
              <el-dropdown-item>蚵仔煎</el-dropdown-item> -->
            </el-dropdown-menu>
          </el-dropdown>
          <!-- <el-button size="small" :disabled="!scope.row.submitStatus"
            @click.native.prevent.stop=" showDetail('wxApply', scope.row)" plain type="success">
            微信进件
          </el-button> -->
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
//eslint-disable-next-line
import { aesDecrypt } from "@/js/Aes";
import {
  // eslint-disable-next-line no-unused-vars
  serviceQueryMerchant, getServiceCreateMerchant, merchantPayInfoQuery, merchantPayIsExists
} from "@/api/service";
import { wxMchPayApply } from "@/api/wxService";
import { swiftApply } from "@/api/swiftpass.js";
export default {
  name: "mchTable",
  data() {
    return {
      tableList: [],
      allTableList: [],
      mchtbshow: true,
      wtycolumnList: []
    }
  },
  mounted() {
    this.setColumn();
    this.getMearchant();
  },
  methods: {
    /**
     * 提交到微信
     * @param {"wx"|"haike"|"swift"} key wx-点击微信进件 haike-点击海科进件 swift-点击微信进件
     * @param {string} merchant_id - 商户ID
     */
    async submitWX(key, merchant_id) {
      switch (key) {
        case "wx": {
          const applyWx = await wxMchPayApply(merchant_id);
          console.log(applyWx);
          if (applyWx && applyWx.applyment_id && applyWx.sheet_no) {
            this.successMessage("进件资料成功提交到微信,详情请到进件记录里查看。");
          }
          break;
        }
        case "haike": {
          break;
        }
        case "swift": {
          const swiftApplyRes = await swiftApply(merchant_id);
          if (swiftApplyRes.code === "0000" && swiftApplyRes.respData && swiftApplyRes.respData.bizCode === "0000") {
            this.successMessage(`随行付进件提交成功`);
          }
          console.log("随行付", swiftApplyRes);

          break;
        }
      }
      /*
      //TODO:微信提交进件 如果微信提交成功 调用 deleteFeedData 删除本地存储的进件信息

      console.log("提交到微信返回：", applyWx); */
    },
    /**
    * 数据过滤
    * @param row 返回的行数据
    * @param column 返回的列信息
    */
    formatter(row, column) {
      return row.submitStatus === false ? '未进件' : '已经进件';
    },
    /**
     * 点击行
     */
    rowClick() {

    },
    /**
     * 搜索
     * @param {string} key 父组件输入框传进来的值
     */
    wtyTableIn(key) {
      this.tableList = this.allTableList.filter(item => item.mch_name.indexOf(key) > -1 || item.sub_name.indexOf(key) > -1 || item.merchant_id.indexOf(key) > -1);
      /* console.log(key);
      for (let i = 1; i < 50; i++) {
        this.tableList.push(this.allTableList[0]);
      } */
    },
    /**
     * 获取商户列表
     */
    async getMearchant() {
      this.mchtbshow = false;
      const result = await getServiceCreateMerchant();
      if (this.testR(result)) {
        this.allTableList = result.data.resp_data;
        await this.getMerchantPayIsExists(this.allTableList);
        this.tableList = this.allTableList;
      }
      this.mchtbshow = true;
    },
    /**
     * 获取到商户是否进件
     */
    async getMerchantPayIsExists(list) {
      for (let i = 0; i < list.length; i++) {
        const state = (await merchantPayIsExists(list[i].merchant_id)).state;
        this.$set(list[i], 'submitStatus', state);
      }
    },
    //TODO:等 /v3/ServiceProvider/Pay/isExists 接口好了用接口获取一下进件状态 也要获取一下进件资料
    /**
     * 设置表格通用列
     */
    setColumn() {
      this.wtycolumnList.push({
        prop: "merchant_id",
        align: "center",
        label: "店铺ID",
        width: "200",
        fixed: "left"
      });
      this.wtycolumnList.push({
        prop: "mch_name",
        align: "center",
        label: "店铺名称",
        width: "300",
        fixed: "left"
      });
      this.wtycolumnList.push({
        prop: "sub_name",
        align: "center",
        label: "店铺简称",
        width: "200",
        fixed: false
      });
      this.wtycolumnList.push({
        prop: "submitStatus",
        align: "center",
        label: "进件状态",
        width: "200",
        fixed: false
      });
      /* this.wtycolumnList.push({
        prop: "applyment_id",
        align: "center",
        label: "微信进件id",
        width: "180",
        fixed: false
      }); */
    },
    /**
     * 获取本地存放的进件信息
     * @param {string} merchant_id - 商户ID
     */
    getFeedData(merchant_id) {
      if (merchant_id) {
        let data = localStorage.getItem("feed_shop_info");
        if (data) {
          let jpData = JSON.parse(data);
          if (jpData[merchant_id]) return JSON.parse(data)[merchant_id];
          else return false;
        } else return false;
      }
    },
    /**
     * 点击操作按钮触发
     * @param {'submit'|'update'|'wxApply'} key 点击的哪个按钮
     * @param {Object} param1 当前行的值
     */
    async showDetail(key, row) {
      //eslint-disable-next-line
      const aesKey = this.$md5(localStorage.getItem("access_token"));
      if (key === 'submit') {
        if (this.getFeedData(row.merchant_id) !== false) {
          this.$emit('mchTableAction', { key, row: { ...this.getFeedData(row.merchant_id), ...row } });
          return;
        }
        this.$emit('mchTableAction', { key, row });
        return;
      };
      if (key === 'update') {
        let updateData = {};
        const updateRes = await merchantPayInfoQuery(row.merchant_id);
        if (updateRes.state === false) {
          this.warnMessage("该商户未进件，无法修改进件信息！");
          this.$emit('mchTableAction', { key, row });
          return;
        }
        updateData = updateRes.data;
        const updateInfo = {
          ...row,
          pass_word: "123",
          mch_type: 1,
          address: updateData.address,
          address_code: updateData.address_code,
          merchant_type: updateData.merchant_type,
          merchant_industry: 1, //行业类型
          mch_name: updateData.merchant_name,
          sub_name: updateData.sub_name,
          license_code: updateData.license_code, //营业执照编号

          img_license: updateData.image_license, //营业执照照片

          img_legal_id_front: updateData.image_legal_person_front, //正面
          img_legal_id_back: updateData.image_legal_person_back, //反面
          img_door: updateData.image_store_front, //门头
          img_in_door: updateData.image_store_in, //内景
          img_cashier: updateData.image_cash_desk, //收银
          img_bank_card: updateData.image_bank_front, //银行卡
          img_warrant: updateData.image_warrant, //授权
          img_beneficiary_id_front: updateData.image_settler_front, //结算人身份证正面
          img_beneficiary_id_back: updateData.image_settler_back, //结算人身份证反面
          wxradio: updateData.settlement_type, //结算方式
          mobile_no: updateData.mobile_no,
          phone: updateData.service_phone,
          service_phone: updateData.service_phone,
          e_mail: updateData.e_mail,
          legal_person_id_start_date: updateData.legal_period_begin,
          legal_person_name: updateData.legal_person_name,
          legal_person_id: updateData.legal_person_id,
          license_start_date: updateData.license_period_begin, //营业执照开始有效期
          license_expire_in: updateData.license_period_end, //营业执照截止有效期
          legal_person_id_expire_in: updateData.legal_period_end, //法人身份证截止有效期
          beneficiary_id: updateData.settler_id, //结算人证件id
          beneficiary_id_start_date: updateData.settler_period_begin, //结算人证件有效期
          beneficiary_id_expire_in: updateData.settler_period_end, //结算人证件有效期
          bank_name: updateData.open_bank_name,
          open_bank_code: updateData.open_bank_code,
          account_name: updateData.bank_account_name, //开户名称
          account_code: updateData.bank_account_no, // 银行账号
          service_charge: updateData.rate
        }
        this.$emit('mchTableAction', { key, row: updateInfo });
      };
      /* if (key === 'wxApply') {
        this.$emit('mchTableAction', { key, row });
      }; */
      /* const jjData = { //进件数据
        merchant_id: this.merchant_id,
        address: this.shop_info.address,
        address_code: this.shop_info.address_code,
        merchant_type: this.shop_info.merchant_type,
        merchant_industry: 1, //行业类型
        merchant_name: this.shop_info.mch_name,
        sub_name: this.shop_info.sub_name,
        license_code: this.shop_info.license_code, //营业执照编号
        image_license: this.shop_info.img_license, //营业执照照片
        image_legal_person_front: this.shop_info.img_legal_id_front, //正面
        image_legal_person_back: this.shop_info.img_legal_id_back, //反面
        image_store_front: this.shop_info.img_door, //门头
        image_store_in: this.shop_info.img_in_door, //内景
        image_cash_desk: this.shop_info.img_cashier, //收银
        image_bank_front: this.shop_info.img_bank_card, //银行卡
        image_warrant: this.shop_info.img_warrant, //授权
        image_settler_front: this.shop_info.img_beneficiary_id_front, //结算人身份证正面
        image_settler_back: this.shop_info.img_beneficiary_id_back, //结算人身份证反面
        settlement_type: this.shop_info.wxradio, //结算方式
        mobile_no: this.shop_info.mobile_no,
        service_phone: this.shop_info.phone,
        e_mail: this.shop_info.e_mail,
        legal_period_begin: legal_person_id_start_date,
        legal_person_name: this.shop_info.legal_person_name,
        legal_person_id: this.shop_info.legal_person_id,
        license_period_begin: this.shop_info.license_start_date, //营业执照开始有效期
        license_period_end: this.shop_info.license_expire_in, //营业执照截止有效期
        legal_period_end: this.shop_info.legal_person_id_expire_in, //法人身份证截止有效期
        settler_id: this.shop_info.beneficiary_id, //结算人证件id
        settler_period_begin: this.shop_info.beneficiary_id_start_date, //结算人证件有效期
        settler_period_end: this.shop_info.beneficiary_id_expire_in, //结算人证件有效期
        open_bank_name: this.shop_info.bank_name,
        open_bank_code: this.shop_info.open_bank_code,
        bank_account_name: this.shop_info.account_name, //开户名称
        bank_account_no: this.shop_info.account_code, // 银行账号
        rate: this.shop_info.service_charge
      } */
    }
  }
}
</script>
<style lang="less" scoped></style>
<!-- 换了表吧 -->